<template>
  <v-dialog scrollable :width="width" v-bind="$attrs" v-on="$listeners" v-bind:value="value">
    <v-card class="g-dialog_card" :height="dialogHeight">
      <v-card-title v-if="title">
        <v-flex>
          <v-layout align-center fill-height class="title-text">
            {{ title }}
            <span v-if="subTitle" class="subTitle">{{ subTitle }}</span>
          </v-layout>
        </v-flex>
        <v-spacer></v-spacer>
        <!-- 메인 비밀번호 변경 팝업에서 X 버튼 미표출 -->
        <v-flex v-if="title !== $t('user.imsiPassChange')">
          <v-layout v-if="closeBtn" justify-end align-center class="close-wrapper">
            <slot name="topBtns"></slot>
            <v-btn icon @click="dialogClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-card-title>
      <!-- pdf Down 진행 전 goto 스크롤을 scrollTop 0을 위한 컨테이너 id값 추가 -->
      <v-card-text class="g-dialog_card_text" :id="idText !== '' ? `g-dialog_text_card_${idText}` : 'g-dialog_text_card'" :style="textHeight !== undefined && textHeight !== null ? 'height:' + textHeight + 'px; ' + etcStyle : '' + etcStyle">
        <slot name="text"></slot>
      </v-card-text>

      <v-card-actions v-if="actionFlag">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GDialog',
  inheritAttrs: true,
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false,
      default: '600'
    },
    height: {
      type: String,
      required: false,
      default: ''
    },
    closeBtn: {
      type: Boolean,
      required: false,
      default: true
    },
    actionFlag: {
      type: Boolean,
      required: false,
      default: true
    },
    textHeight: {
      type: Number,
      required: false
    },
    // goTo scroll 동적 id값을 위한 props 추가
    idText: {
      type: String,
      required: false,
      default: ''
    },
    etcStyle: {
      type: String,
      required: false,
      default: ''
    },
    subTitle: { // 타이틀 옆에 글자
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
    (function () { // make vuetify dialogs movable
      const d = {}
      document.addEventListener('mousedown', e => {
        const closestDialog = e.target.closest('.v-dialog.v-dialog--active')
        if (e.button === 0 && closestDialog != null && (e.target.classList.contains('v-card__title') || e.target.classList.contains('title-text'))) { // element which can be used to move element
          d.el = closestDialog // element which should be moved
          d.mouseStartX = e.clientX
          d.mouseStartY = e.clientY
          d.elStartX = d.el.getBoundingClientRect().left
          d.elStartY = d.el.getBoundingClientRect().top
          d.el.style.position = 'fixed'
          d.el.style.margin = 0
          d.oldTransition = d.el.style.transition
          d.el.style.transition = 'none'
        }
      })
      document.addEventListener('mousemove', e => {
        if (d.el === undefined) return
        d.el.style.left = Math.min(
          Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
          window.innerWidth - d.el.getBoundingClientRect().width
        ) + 'px'
        d.el.style.top = Math.min(
          Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
          window.innerHeight - d.el.getBoundingClientRect().height
        ) + 'px'
      })
      document.addEventListener('mouseup', () => {
        if (d.el === undefined) return
        d.el.style.transition = d.oldTransition
        d.el = undefined
      })
      setInterval(() => { // prevent out of bounds
        const dialog = document.querySelector('.v-dialog.v-dialog--active')
        if (dialog === null) return
        dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + 'px'
        dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + 'px'
      }, 100)
    })()
  },
  watch: {
  },
  computed: {
    dialogHeight () {
      if (this.height === undefined || this.height === null || this.height === '') {
        return undefined
      }

      return typeof this.height === 'number'
        ? this.height
        : this.height
    },

    cardTextStyle () {
      const style = {
        overflowY: 'auto'
      }

      if (this.textHeight !== undefined && this.textHeight !== null) {
        style.height = `${this.textHeight}px`
      }

      if (this.etcStyle) {
        return `${style.height ? `height: ${style.height};` : ''} overflow-y: auto; ${this.etcStyle}`
      }

      return style
    }
  },
  methods: {
    dialogClose: function () {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
/* .v-dialog > .v-card > .v-card__title {padding:0 0 0 16px;font-size: 16px;}
.g-dialog_card {overflow: hidden;}
.g-dialog_card >>> .v-card__title {height:40px;line-height:40px;background-color: #fff;font-size: 16px;font-weight: normal;font-style: normal;font-stretch: normal;letter-spacing: normal;color: #292929;border-bottom:1px solid #292929;cursor: grab;}
.g-dialog-search_card >>> .v-card__title:active {cursor: grabbing;}
.g-dialog_card >>> .v-card__title .title {width:calc(100% - 56px);}
.g-dialog_card >>> .v-card__title .title .title-text {display: block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.g-dialog_card >>> .v-card__title .close-wrapper {margin-right:4px;}

.g-dialog_card >>> .brower-error-content {padding:16px;}
.g-dialog_card >>> .v-card__text {color:#888;background-color:#fff;}
.g-dialog_card.v-card > .v-card__text {padding:16px;min-height:100px;} */
/* .g-dialog_card {padding:12px 24px 24px;} */
.g-dialog_card {padding:12px 24px}
.g-dialog_card >>> .v-card__title {padding:0;font-size: 16px;height:48px;line-height:48px;background-color: #fff;font-family: Pretendard !important;font-size: 20px !important;font-weight: 600 !important;font-style: normal;font-stretch: normal;letter-spacing: normal;color: #444;border-bottom:1px solid #000;cursor: grab;}
.g-dialog_card >>> .v-card__title .title .title-text {display: block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}

.g-dialog_card >>> .v-card__text {color:#888;background-color:#fff;min-height:100px;padding:16px 0;overflow-x: hidden;overflow-y: auto;}

.v-dialog > .v-card > .v-card__actions { padding-top: 10px; }
.g-dialog_card >>> .v-card__actions {padding:0;width:100%;border-top:1px solid #cecece;text-align: center;display: block;}
.g-dialog_card >>> .v-card__actions button {min-width: 104px;height:48px;border:0;font-size: 16px;font-weight: 600;font-style: normal;font-stretch: normal;letter-spacing: normal;text-align: center;}
.g-dialog_card >>> .v-card__actions .v-btn + .v-btn {margin:0;}
.g-dialog_card >>> .v-card__actions .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {box-shadow:none;-webkit-box-shadow:none;}
.g-dialog_card >>> .v-card__actions .flex button.v-btn--block {border-radius: 0;}

.g-dialog_card >>> .v-input--is-readonly input {color: #999;}
.g-dialog_card >>> .v-input--is-readonly .v-label {color: #999;}
.g-dialog_card >>> .v-input--is-readonly > .v-input__control > .v-input__slot:before {border-color: #bbb;}

.g-dialog_card >>> .v-bottom-navigation { height: 48px !important; padding: 0; box-shadow: none; }
.g-dialog_card >>> .v-bottom-navigation .v-btn:not(.v-btn--active) {color:#fff !important;}
.g-dialog_card >>> .v-bottom-navigation .v-btn {width:100%;margin:0;line-height:48px !important;font-family: Pretendard;font-size: 16px;font-weight: 600;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;text-align: left;color: #fff !important;max-width: none !important;}
.g-dialog_card >>> .v-item-group.v-bottom-navigation .v-btn .v-btn__content {flex-direction: inherit;}

.g-dialog_card >>> .text { color: #444; margin-bottom: 12px; }
.g-dialog_card >>> .text SPAN.count { color: #2373c4; }

.g-dialog_card >>> .v-card__title .subTitle {font-size: 15px !important; margin-left: 5px;}

.g-dialog_card {
  display: flex;
  flex-direction: column;
}

.g-dialog_card_text {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
</style>
